module.exports = __webpack_public_path__ + "41dea62c7bc84a3f155f1577cc2dd009.webp";